import { render, staticRenderFns } from "./StoryOnboarding.vue?vue&type=template&id=90d0094c"
import script from "./StoryOnboarding.vue?vue&type=script&lang=js"
export * from "./StoryOnboarding.vue?vue&type=script&lang=js"
import style0 from "./StoryOnboarding.vue?vue&type=style&index=0&id=90d0094c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports